import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Typography, Box } from '@mui/material';

const LandingPage: React.FC = () => {
    const navigate = useNavigate();

    const handleNavigateHome = () => {
        navigate('/home');
    };

    return (
        <div style={{
            margin: '0',
            padding: '0',
            height: '100vh',
            backgroundColor: '#000',
            overflowX: 'hidden'
        }}>

            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                sx={{backgroundColor: '#000', width: '100%'}}
            >
                <Box sx={{flexGrow: 1, textAlign: 'center'}}>
                    <img
                        src="/landing/landing-logo.png"
                        alt="Linknity Logo"
                        style={{height: '90px', margin: '2rem'}}
                    />
                </Box>

                <h1 style={{color: 'white', fontSize: '20px'}}>
                    링크 주소 모음 사이트 No.1 링크니티
                </h1>

                <Box
                    sx={{
                        position: 'relative',
                        textAlign: 'center',
                        marginBottom: '2rem',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        maxWidth: '40%', minWidth: '300px'
                    }}
                >
                    {/* 배경 이미지 설정 */}
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundImage: 'url(/landing/landing-description-background.png)',
                            backgroundSize: 'contain',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat', // 이미지가 반복되지 않도록 설정
                            zIndex: 1,
                        }}
                    />

                    {/* 이미지 위에 배치될 텍스트 */}
                    <h2
                        style={{
                            color: 'white',
                            zIndex: 2,
                            textShadow: '0.5px 0.5px 2px rgba(139, 69, 19, 0.5)',
                            fontSize: 'clamp(0.6rem, 1.2vw, 1.8rem)', // 글자 크기 조정
                            padding: '0 3rem', // 작은 화면에서 글자가 이미지 밖으로 나가는 것을 방지
                            textAlign: 'center', // 텍스트 가운데 정렬
                        }}
                    >
                        링크니티는 실생활에 자주 이용하는 모든 링크를 보다 쉽게 찾아볼 수 있게 모음한 링크 주소 소개 사이트 입니다.
                    </h2>
                </Box>


                <Box sx={{flexGrow: 1, textAlign: 'center'}}>
                    <img
                        src="/landing/landing-go-home.png"
                        alt="Linknity Description"
                        style={{maxWidth: '20%', minWidth: '150px', cursor: 'pointer'}}
                        onClick={handleNavigateHome}
                    />
                </Box>


                <Box
                    sx={{
                        maxWidth: '800px', // 텍스트 컨테이너의 최대 너비
                        textAlign: 'left', // 텍스트는 왼쪽 정렬
                        margin: 'auto', // 가운데 정렬
                        color: 'white', // 텍스트 색상
                        padding: '1rem', // 내부 패딩
                    }}
                >
                    <Box display="flex" alignItems="center" sx={{marginBottom: '1rem'}}>
                        <Box
                            sx={{
                                width: '20px', // 네모의 너비
                                height: '20px', // 네모의 높이
                                backgroundColor: 'white', // 네모의 색상
                                borderRadius: '3px', // 모서리 둥글게
                                marginRight: '8px' // 텍스트와의 간격
                            }}
                        />
                        <Typography variant="h3" color="white" style={{ fontSize: '16px'}}>
                            링크니티란?
                        </Typography>
                    </Box>
                    <Typography variant="body2" color="white" mb={4} sx={{paddingLeft: '25px', lineHeight: '1.8'}}>
                        링크니티는 여러 이용자분들이 추천하고 키워드별로 연관성을 지어 여러 웹사이트를 인기별로 모아 추천하고 안내 해드리고 있습니다.
                    </Typography>

                    <Box display="flex" alignItems="center" sx={{marginBottom: '1rem'}}>
                        <Box
                            sx={{
                                width: '20px', // 네모의 너비
                                height: '20px', // 네모의 높이
                                backgroundColor: 'white', // 네모의 색상
                                borderRadius: '3px', // 모서리 둥글게
                                marginRight: '8px' // 텍스트와의 간격
                            }}
                        />
                        <Typography variant="h3" color="white" style={{ fontSize: '16px'}}>
                            왜 개설되었나?
                        </Typography>
                    </Box>
                    <Typography variant="body2" color="white" mb={4} sx={{paddingLeft: '25px', lineHeight: '1.8'}}>
                        이러한 여럿 이유로 보다 쉽고 편리하게 클릭한번으로 손쉽게 내가 찾았던 알고리즘의 원하는 홈페이지를 찾고 들어갈수 있게끔,
                        하기위해 보다 편리성을위해 개설하게 되었습니다. 또한 더 나은 사이트들을 찾고 더욱 더 나은 플랫폼이 되고자 개설하게 되었습니다.
                        저희 홈페이지가 여러 자신이 찾기힘든 사이트를 손쉽게 찾고 더욱 편리한 세상이 될수있게금 길라잡이 역할이 되도록 하겟습니다.
                    </Typography>

                    <Box display="flex" alignItems="center" sx={{marginBottom: '1rem'}}>
                        <Box
                            sx={{
                                width: '20px', // 네모의 너비
                                height: '20px', // 네모의 높이
                                backgroundColor: 'white', // 네모의 색상
                                borderRadius: '3px', // 모서리 둥글게
                                marginRight: '8px' // 텍스트와의 간격
                            }}
                        />
                        <Typography variant="h3" color="white" style={{ fontSize: '16px'}}>
                            링크니티 기능
                        </Typography>
                    </Box>
                    <Typography variant="body2" color="white" mb={4} sx={{paddingLeft: '25px', lineHeight: '1.8'}}>
                        링크니티는 다양한 키워드로 방문자수 혹은 만족도 높은 사이트, 인기 있는 사이트를 분류하며 직접 자체 평가로 홈페이지들을 추천하며
                        그렇게 분류된 곳을 보다 쉽게 찾아 들어가서 보다 높은 만족도를 쉽게 찾을수있게끔 하였습니다.
                        현대사회에서 폰으로 OTT외에 유튜브 모든 공간이 영상을 보게되어있어 더욱 더 필요로하는 링크기능을 추천합니다.
                        개인적인 일, 업무, 지식, 취미 등 다양한 목적을 위해 사용될 수 있으며 유용한것들과 자신에게 필요로한 것들을 볼수있다.
                    </Typography>

                    <Box display="flex" alignItems="center" sx={{marginBottom: '1rem'}}>
                        <Box
                            sx={{
                                width: '20px', // 네모의 너비
                                height: '20px', // 네모의 높이
                                backgroundColor: 'white', // 네모의 색상
                                borderRadius: '3px', // 모서리 둥글게
                                marginRight: '8px' // 텍스트와의 간격
                            }}
                        />
                        <Typography variant="h3" color="white" style={{ fontSize: '16px'}}>
                            링크 순위란?
                        </Typography>
                    </Box>
                    <Typography variant="body2" color="white" mb={4} sx={{paddingLeft: '25px', lineHeight: '1.8'}}>
                        유료 비용을 받지 않고 이용하시는분들의 방문자 데이터와 그들의 평가만으로 순위가 적용되는 것 임을 알려드립니다.
                        투명하고 클린하게 정보를 제공합니다.
                    </Typography>

                    <Box display="flex" alignItems="center" sx={{marginBottom: '1rem'}}>
                        <Box
                            sx={{
                                width: '20px', // 네모의 너비
                                height: '20px', // 네모의 높이
                                backgroundColor: 'white', // 네모의 색상
                                borderRadius: '3px', // 모서리 둥글게
                                marginRight: '8px' // 텍스트와의 간격
                            }}
                        />
                        <Typography variant="h3" color="white" style={{ fontSize: '16px'}}>
                            링크니티 가치 희소성
                        </Typography>
                    </Box>
                    <Typography variant="body2" color="white" mb={4} sx={{paddingLeft: '25px', lineHeight: '1.8'}}>
                        있지만 그 안에서 더 보다 나은 신뢰할수있고 다양한 메뉴와 다양한 카테고리로 유저분들의 귀와 눈을 만족시키며 더 나아가
                        편의성 측면에서는 무엇보다 만족스러운 커뮤니티를 자부합니다.
                    </Typography>

                    <Box display="flex" alignItems="center" sx={{marginBottom: '1rem'}}>
                        <Box
                            sx={{
                                width: '20px', // 네모의 너비
                                height: '20px', // 네모의 높이
                                backgroundColor: 'white', // 네모의 색상
                                borderRadius: '3px', // 모서리 둥글게
                                marginRight: '8px' // 텍스트와의 간격
                            }}
                        />
                        <Typography variant="h3" color="white" style={{ fontSize: '16px'}}>
                            궁극적 컨텐츠
                        </Typography>
                    </Box>
                    <Typography variant="body2" color="white" mb={4} sx={{paddingLeft: '25px', lineHeight: '1.8'}}>
                        홈페이지를 찾을수 있게끔 하며 각기다른 취미,금융,이색 스포츠 또한 여러한 방도로 맞춘 링크를 제공하고자 합니다. 여러 나이대가
                        관심과 흥미를 가지게끔 하며 보다 좋은 정보의 링크들을 쉽게 서치할수있도록 함에 초점을 두고 있습니다.
                        이용자분들이 스마트폰으로 여러정보를 확인하고 평가하고 순기능들을 쉽게 이용하듯이 저희도
                        그와 같은 방향으로 여러 이용하시는 분들에게 현 정보회시대에 걸맞춰 맞춤형 정리를 통해 사용자의 필요성에 맞는 효율적인 정보와
                        능률을 찾고자하고 여러 정보성과 보안성을 뛰어 보호 할수있으며 데이터를 기반으로 한 신뢰할 수 있는 홈페이지가 되게끔합니다.
                        주기적으로 데이터를 최신화하여 인기사이트를 제공하겠습니다.
                    </Typography>
                </Box>
            </Box>
        </div>

    );
};

export default LandingPage;
